const isEqual = (a: any, b: any): boolean => {
  // Same value
  if (a === b) return true;

  // If either is null or not an object, they aren't equal (primitives already handled)
  if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object') {
    return false;
  }

  // Arrays
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i += 1) {
      if (!isEqual(a[i], b[i])) return false;
    }
    return true;
  }

  // If one is array and the other is not
  if (Array.isArray(a) || Array.isArray(b)) return false;

  // Objects
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (let n = 0; n < keysA.length; n += 1) {
    if (!Object.prototype.hasOwnProperty.call(b, keysA[n])) return false;
    if (!isEqual(a[keysA[n]], b[keysA[n]])) return false;
  }

  return true;
};

export default isEqual;
